export default __webpack_public_path__ + "static/media/dummy-image.1d42a8d3.png";